// palette util: http://mcg.mbitson.com/#!?mcgpalette0=%23d20000

export const primary = {
    50: '#fae0e0',
    100: '#f2b3b3',
    200: '#e98080',
    300: '#e04d4d',
    400: '#d92626',
    500: '#d20000',
    600: '#cd0000',
    700: '#c70000',
    800: '#c10000',
    900: '#b60000',
    A100: '#ffdfdf',
    A200: '#ffacac',
    A400: '#ff7979',
    A700: '#ff5f5f',
    'contrastDefaultColor': 'light',
};

export default primary;
